import { FunctionalComponent, h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import styles from "./documentViewerStyles.css";
import ChatbotPdf from "../../routes/pdf/ChatbotPdf";
import { useAppSelector } from "../../redux/hooks";
import ChatbotSheet from "../../routes/sheet/ChatbotSheet";
import ChatbotVideo from "../../routes/video/ChatbotVideo";
import CloseIcon from "../../assets/icons/closeIcon";
import ExpandIcon from "../../assets/icons/ExpandIcon";
import DownloadIcon from "../../assets/icons/downloadIcon";
import { isMobileOnly as isMobileOnlyReact } from "react-device-detect";
import { getIsEdge } from "../../configs/env";
import WatermarkOverlay from "../WatermarkOverlay";
import logger from "../../logger";
import { useDispatch } from "react-redux";
import { setResultSrc } from "../../redux/slices/appearanceSlice";

interface IProps {
  isDrawerOpen: boolean;
  docDetail: any;
  setDrawerOpen: (value: boolean) => void;
  handleToggleFullScreen: () => void;
  handleToggleEpandScreen?: () => void;
  videoContainerRef?: any;
  chatbotFlag?: string;
  closeContainerRef?: any;
  sasToken?: string;
}

const DocumentViewer: FunctionalComponent<IProps> = ({
  isDrawerOpen,
  docDetail,
  setDrawerOpen,
  handleToggleFullScreen,
  handleToggleEpandScreen,
  videoContainerRef,
  chatbotFlag,
  closeContainerRef,
  sasToken,
}) => {
  const alias = useAppSelector((state) => state.alias);
  const appearance = useAppSelector((state) => state.appearance);
  const dispatch = useDispatch();
  logger.log({
    message: "Appearance state loaded",
    portal_alias: alias.portalId,
    document_name: docDetail?.guid || docDetail?.docGuid,
  });
  const isExpandedView = useRef(false);
  const topContainer = useRef<HTMLDivElement>(null);
  const [srcUrl, setSrcUrl] = useState("");
  const isSubtitle = useRef<HTMLDivElement>(null);
  const showSubtitle = useRef(false);
  const [isMobileExpand, setIsMobileExpand] = useState(false);
  const [isEdge, setIsEdge] = useState(getIsEdge());
  const selectRef = useRef<HTMLSelectElement>(null);

  const handleSelectClick = () => {
    if (selectRef.current) {
      const optionToSelect = selectRef.current.querySelector(
        "option[value='page-width']"
      );
      if (optionToSelect) {
        // optionToSelect.selected = true;
        // Trigger a `change` event to notify any listeners
        selectRef.current.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  };
  const toggleSubtitles = () => {
    showSubtitle.current = !showSubtitle.current;
    if (showSubtitle.current && isSubtitle.current) {
      isSubtitle.current.style.textDecoration = "line-through";
    }
    if (!showSubtitle.current && isSubtitle.current) {
      isSubtitle.current.style.textDecoration = "none";
    }
    (window as any).dispatchEvent(new CustomEvent("toggle-subtitles"));
  };
  useEffect(() => {
    if (isDrawerOpen && isExpandedView.current && topContainer.current) {
      isExpandedView.current = !isExpandedView.current;
      topContainer.current.style.paddingTop = "36px";
      // topContainer.current.style.padding = "10px";
    }
  }, [isDrawerOpen]);

  return (
    <div
      key={docDetail?.guid}
      ref={topContainer}
      className={`${styles.sideDrawer} ${
        isDrawerOpen && docDetail.guid ? styles.open : ""
      }`}
      style={{
        paddingTop: isEdge
          ? "36px"
          : docDetail?.type === "pdf" && !isMobileOnlyReact
          ? "36px"
          : isMobileOnlyReact
          ? ""
          : "28px",
        position: "relative",
      }}
    >
      <div
        className={`${styles.closeContainer} ${
          isMobileExpand ? styles.closeContainerTwo : ""
        }`}
        ref={closeContainerRef}
      >
        {(docDetail?.type === "sheet" ||
          docDetail?.type === "xls" ||
          docDetail?.type === "csv") &&
          !isEdge &&
          ((appearance.enableFileRepositoryDestinationLink &&
            appearance.fileRepositoryDestinationLink.startsWith("http")) ||
            (!appearance.enableFileRepositoryDestinationLink &&
              !appearance.fileRepositoryDestinationLink)) && (
            <a
              href={
                appearance.fileRepositoryDestinationLink.startsWith("http")
                  ? appearance.fileRepositoryDestinationLink
                  : srcUrl
              }
              download
            >
              <DownloadIcon />
            </a>
          )}
        {docDetail?.type !== "sheet" &&
          docDetail?.type !== "xls" &&
          docDetail?.type !== "csv" &&
          docDetail?.type !== "pdf" && (
            <div
              className={styles.subtitlesButton}
              onClick={() => {
                toggleSubtitles();
              }}
            >
              <span className={styles.cc} ref={isSubtitle}>
                CC
              </span>
            </div>
          )}
        {!isMobileOnlyReact &&
        (docDetail?.type === "xls" ||
          docDetail?.type === "csv" ||
          docDetail?.type === "pdf") ? (
          <span
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
            }}
            onClick={() => {
              if (handleToggleEpandScreen) handleToggleEpandScreen();
              isExpandedView.current = !isExpandedView.current;
              if (isExpandedView.current && topContainer.current) {
                topContainer.current.style.paddingTop = "0px";
                topContainer.current.style.padding = "0px";
              }
              if (!isExpandedView.current && topContainer.current) {
                topContainer.current.style.paddingTop = "36px";
              }
            }}
          >
            <ExpandIcon />
          </span>
        ) : docDetail?.type === "xls" ||
          docDetail?.type === "csv" ||
          docDetail?.type === "pdf" ? (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setIsMobileExpand(!isMobileExpand);
            }}
          >
            <ExpandIcon />
          </span>
        ) : null}

        <span
          onClick={() => {
            if (setDrawerOpen && handleToggleEpandScreen) {
              setDrawerOpen(false);
              dispatch(setResultSrc(""));
              if (isExpandedView.current) handleToggleEpandScreen();
              setIsMobileExpand(false);
            }
          }}
          style={{
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CloseIcon />
        </span>
      </div>
      {docDetail?.type === "csv" || docDetail?.type === "xls" ? (
        <ChatbotSheet
          workspaceId={alias.workspaceId}
          docId={docDetail.docGuid}
          guid={docDetail.guid}
          kappId={docDetail.kapp}
          chatbotFlag={chatbotFlag}
          isDrawerOpen={isDrawerOpen}
          srcUrl={srcUrl}
          setSrcUrl={setSrcUrl}
          isMobileExpand={isMobileExpand}
          isWatermarkEnabled={appearance.documentWatermark}
        />
      ) : docDetail?.type === "pdf" ? (
        <ChatbotPdf
          workspaceId={alias.workspaceId}
          docId={docDetail?.docGuid}
          guid={docDetail?.guid}
          kappId={docDetail?.kapp}
          page={docDetail?.page}
          chatbotFlag={chatbotFlag}
          matches={{
            highlight: "true",
          }}
          isDrawerOpen={isDrawerOpen}
          isMobileExpand={isMobileExpand}
          sasToken={sasToken}
        />
      ) : (
        <ChatbotVideo
          workspaceId={alias.workspaceId}
          docGuid={docDetail?.docGuid}
          guid={docDetail?.guid}
          kappId={docDetail?.kapp}
          handleToggleFullScreen={handleToggleFullScreen}
          setDrawerOpen={setDrawerOpen}
          isDrawerOpen={isDrawerOpen}
          videoContainerRef={videoContainerRef}
        />
      )}
    </div>
  );
};

export default DocumentViewer;
